<template>
  <div>
    <div class="modelReg__title">
      <h3>{{ $t('modal.modalStateEnum.CodeFromEmail.title') }}</h3>
      <p>{{ $t('modal.modalStateEnum.CodeFromEmail.subTitle') }} {{ form.email }}</p>
    </div>
    <UForm class="modelReg__form">
      <UiBaseInputN
        v-model="form.codeFromEmail"
        type-input="text"
        :label="$t('modal.modalStateEnum.CodeFromEmail.input')"
        :placeholder="$t('modal.modalStateEnum.CodeFromEmail.input')"
        :error="v$.codeFromEmail.$error"
        :errors="v$.codeFromEmail.$errors"
        :show-error="true"
        @change="v$.codeFromEmail.$touch"
      ></UiBaseInputN>

      <div class="modelReg__grid-btn">
        <UiBaseButton
          size="xxl"
          :label="$t('modal.modalStateEnum.CodeFromEmail.btnResend')"
          variant="soft"
          @click="sendCodeFromEmailAgain"
        ></UiBaseButton>
        <UiBaseButton
          :disabled="v$.$invalid"
          size="xxl"
          :label="$t('modal.modalStateEnum.CodeFromEmail.btnFurther')"
          @click="setPassword"
        ></UiBaseButton>
      </div>
    </UForm>
  </div>
</template>

<script setup>
/* v8 ignore file */
import { useVuelidate } from '@vuelidate/core';
import { useAuthStore } from '~/features/auth';
import { useUserProfileStore } from '@entities/user';
import { useRulesForForm } from '@shared/lib';

const { RulesForFormCodeFromEmail } = useRulesForForm();

const storeAuth = useAuthStore();
const storeUserProfile = useUserProfileStore();
const props = defineProps({
  userData: {
    type: Object,
    required: true,
    default: () => ({
      email: '',
      password: '',
      confirmPassword: '',
      twoFA: '',
      codeFromEmail: '',
    }),
  },
});

const form = ref(props.userData);

const rules = computed(() => ({
  codeFromEmail: RulesForFormCodeFromEmail(),
}));
const v$ = useVuelidate(rules, form);

const sendCodeFromEmailAgain = async () => {

};

const setPassword = async () => {
  const params = {
    codeFromEmail: form.value.codeFromEmail,
  };
  // const codeFromEmailResult = await apiAuth.codeFromEmail(params);
  // if (!codeFromEmailResult.error.value) {
  // storeModal.stateAuthModal(modalStateEnum.changePassword)
  // }
};
</script>

<style scoped lang="scss"></style>


